import FormField from "components/FormField";
import React from "react";
import { twMerge } from "tailwind-merge";
import { useSelector } from "react-redux";
import { ReactComponent as InputIcon } from "assets/icons/input.svg";
import { selectIsGameOver, selectLevel } from "store/game/selectors";
import Timeline from "components/Timeline";
import ItemHint from "./ItemHint";
import ItemDescription from "./ItemDescription";

const GridSlotControls = React.forwardRef(({ data, ...props }, inputRef) => {
  // Redux
  const isGameOver = useSelector(selectIsGameOver);
  const selectedLevel = useSelector(selectLevel);

  // Local
  const [value, setValue] = React.useState("");

  // Computed
  const partitionType = data?.type;
  const partitionOptions = selectedLevel?.parts[partitionType];
  const hasHint = partitionOptions?.hint;
  const duration = partitionOptions?.time;
  const timelineEnabled = !isGameOver && !props.disabled;

  const handleChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/\D/g, "");
    inputValue = inputValue.slice(0, String(data?.code).length);
    setValue(inputValue);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (inputRef.current) {
      const code = inputRef.current.value;

      if (code) {
        props.onSubmit && props.onSubmit(code);
      } else {
        inputRef.current.focus();
      }
    }
  };

  return (
    <>
      {hasHint && (
        <ItemHint
          enabled={timelineEnabled}
          seconds={duration}
          hint={data?.code}
          isGameOver={isGameOver}
        />
      )}

      <ItemDescription text={data?.description} />

      <form
        className=" overflow-hidden flex items-center gap-2 p-1 text-indigo-800 absolute bottom-0 z-20"
        onSubmit={handleSubmit}
      >
        <FormField
          type="text"
          value={value}
          ref={inputRef}
          onChange={handleChange}
          wrapperProps={{ noWrap: true }}
          disabled={isGameOver || props.disabled}
          placeholder={String(data?.code).replace(/./g, "0")}
          className={twMerge(
            "w-full inline-block p-0 focus:outline-orange-400 outline-1 backdrop-blur-sm bg-black/30 text-indigo-50 font-semibold",
            "text-center text-3xl placeholder-slate-300 relative cursor-pointer",
            isGameOver ? "opacity-50" : ""
          )}
        />

        <InputIcon
          className="absolute -rotate-90 left-5 z-50"
          style={{ width: "1.5rem", height: "1.5rem", strokeWidth: "2px" }}
        />

        <Timeline
          duration={duration}
          onEnd={props.onTimeout}
          className="absolute inset-1 opacity-50 rounded"
          enabled={timelineEnabled}
          onClick={() => {
            if (inputRef.current) {
              inputRef.current.focus();
            }
          }}
        />
      </form>
    </>
  );
});

GridSlotControls.displayName = "GridSlotControls";

export default GridSlotControls;
